import React from 'react';
import { UrgencyBar } from '../components/sales/UrgencyBar';
import { SalesHero } from '../components/sales/SalesHero';
import { HookSection } from '../components/sales/HookSection';
import { PainSection } from '../components/sales/PainSection';
import { RevelationSection } from '../components/sales/RevelationSection';
import { OfferVitrine } from '../components/sales/OfferVitrine';
import { TransformationBand } from '../components/sales/TransformationBand';
import { TestimonialsCarousel } from '../components/sales/TestimonialsCarousel';
import { FaqAccordion } from '../components/sales/FaqAccordion';
import { GuaranteeBlock } from '../components/sales/GuaranteeBlock';
import { FinalCta } from '../components/sales/FinalCta';
import { SalesStickyBar } from '../components/sales/SalesStickyBar';
import { LiveViewers } from '../components/sales/LiveViewers';
import { SalesNotifications } from '../components/sales/SalesNotifications';
import { CHECKOUT_URL, OFFER_ANCHOR, faqs, finalCta, guarantee, hero, hook, liveViewers, offer, pain, revelation, salesNotificationProduct, salesNotifications, salesStickyBar, socialProof, testimonials, transformation, urgencyBar } from '../data/salesPage';
interface SalesPageProps {
  showStickyCta: boolean;
  showLiveActivity: boolean;
}
export function SalesPage({
  showStickyCta,
  showLiveActivity
}: SalesPageProps) {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink" data-id="element-356" data-mp="3tj4318mztdws">
      <UrgencyBar label={urgencyBar.label} text={urgencyBar.text} spotsLeft={urgencyBar.spotsLeft} data-id="element-357" data-mp="3tg853kb5ap8c" />

      <main data-id="element-358" data-mp="3jkembj6u1zi4">
        <SalesHero content={hero} data-id="element-359" data-mp="3jk4vxuhvlqbw" />
        <HookSection content={hook} data-id="element-360" data-mp="3jj3ixkhautrj" />
        <PainSection content={pain} data-id="element-361" data-mp="3jm98f0tubxns" />
        <RevelationSection content={revelation} data-id="element-362" data-mp="3fjkyepte4kp8" />
        <OfferVitrine content={offer} checkoutUrl={CHECKOUT_URL} data-id="element-363" data-mp="3fkw2yruntwhe" />
        <TransformationBand items={transformation} data-id="element-364" data-mp="28612qqj4467w" />
        <TestimonialsCarousel title={socialProof.title} subtitle={socialProof.subtitle} stats={socialProof.stats} items={testimonials} data-id="element-365" data-mp="243nzc8ru8kea" />
        <FaqAccordion items={faqs} data-id="element-366" data-mp="25iz18vmkbt3f" />
        <GuaranteeBlock content={guarantee} data-id="element-367" data-mp="2akfxuey0kte7" />
        <FinalCta content={finalCta} checkoutUrl={OFFER_ANCHOR} price={offer.price} totalValue={offer.totalValue} data-id="element-368" data-mp="2aj4wels1jxq9" />
      </main>

      <footer className="border-t border-white/[0.07] bg-ink px-5 pb-24 pt-10 sm:px-6 md:pb-10" data-id="element-369" data-mp="20kfdcpoes78f">
        <div className="mx-auto max-w-3xl text-center" data-id="element-370" data-mp="1mtk1r5mizc15">
          <p className="font-mono text-[10px] tracking-[0.22em] text-gold/80" data-id="element-371" data-mp="1rksas0jy0vds">NEURO-PUREZA</p>
          <p className="mt-3 text-[12.5px] font-light leading-relaxed text-ash/70" data-id="element-372" data-mp="1cw5yy8tiylrb">
            Este material es de carácter educativo y espiritual, y no sustituye el consejo médico,
            psicológico ni pastoral profesional. Los resultados varían según cada persona.
          </p>
          <p className="mt-4 font-mono text-[10px] tracking-[0.12em] text-ash/50" data-id="element-373" data-mp="13xtyzg6rqbm7">
            © {new Date().getFullYear()} — Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {showLiveActivity && <>
          <LiveViewers baseCount={liveViewers.baseCount} label={liveViewers.label} note={liveViewers.note} data-id="element-374" data-mp="kaftssjpw7oz" />
          <SalesNotifications items={salesNotifications} product={salesNotificationProduct} data-id="element-375" data-mp="y72vf8mm7m18" />
        </>}

      {showStickyCta && <SalesStickyBar label={salesStickyBar.label} hint={salesStickyBar.hint} buttonLabel={salesStickyBar.buttonLabel} href={OFFER_ANCHOR} data-id="element-376" data-mp="186tod5vj1sz7" />}
    </div>;
}